import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './SideDrawer.module.css';

const sideDrawer = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);
  return (
    <div style={{ top: props.topPosition }} className={containerClasses.join(' ')}>
      <FontAwesomeIcon className={classes.CloseOpenIcon} icon={props.show ? 'chevron-left' : 'chevron-right'} onClick={props.toggle} />
      <div style={{ width: props.show ? props.width : '0px' }} className={classes.ContainerContents}>
        {props.children}
      </div>
    </div>
  );
};

export default sideDrawer;
